import { Image, Stack, Text } from "@bookingcom/bui-react";

export const UserManagementEmptyState = () => {
  return (
    <Stack alignItems="center" justifyContent="center" gap={2} mixin={{ paddingBlockStart: 16 }}>
      <Image
        asset={{
          setName: "illustrations-partner-thumbnails",
          assetName: "Search",
        }}
        width={30}
      />
      <Stack alignItems="center" gap={1}>
        <Text variant="strong_1">No users found</Text>
        <Text variant="body_2" color="neutral_alt">
          Try adjusting your search criteria
        </Text>
      </Stack>
    </Stack>
  );
};
